// extracted by mini-css-extract-plugin
module.exports = {"icons":"MoscowCreditBankBlockIcons_icons_2ZSX_"};